import script from "./FormTab.vue?vue&type=script&lang=js"
export * from "./FormTab.vue?vue&type=script&lang=js"

import "./FormTab.vue?vue&type=style&index=0&id=77bac970&lang=scss"

const __exports__ = script;

export default __exports__